import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from "bootstrap"
import { DRAWER_ID } from "./quick_action_launcher_controller"

// Fiche créée : ferme le panneau, puis ouvre la fiche ou rafraîchit la page en cours (Turbo 8
// morph : un index ouvert affiche la nouvelle ligne sans perdre le défilement).
export default class extends Controller {
  static values = { url: String }

  connect() {
    const drawer = document.getElementById(DRAWER_ID)
    if (drawer) Offcanvas.getOrCreateInstance(drawer).hide()
    setTimeout(() => {
      if (drawer) {
        Offcanvas.getInstance(drawer)?.dispose()
        drawer.remove()
      }
      if (this.urlValue) window.Turbo.visit(this.urlValue)
      else window.Turbo.visit(window.location.href, { action: "replace" })
    }, 350)
  }
}
